const FOOTER_HEIGHT = "72px";

const WIZARD_CONTAINER_STYLES = {
  bg: "white",
  borderRadius: "md",
  borderWidth: "hairline",
  borderStyle: "solid",
  borderColor: "base.border",
  p: 6,
};

// Every id the partner config can reference (destination, source, sync, model)
// maps to a Postgres `bigint` column, so anything other than a numeric value
// will blow up at the database layer with `invalid input syntax for type
// bigint`. The config is `JSON.parse(atob(...))`-decoded from a URL param
// with no schema coercion, so a partner may encode an id as either a string
// or a JS number — accept both shapes here, and `String()` at the query
// call site. The gate also rejects empty strings, the literal `"undefined"`
// produced by `String(undefined)`, and any non-positive / non-integer / unsafe
// number.
export const isNumericPartnerId = (id: unknown): id is string | number =>
  (typeof id === "string" && /^\d+$/.test(id)) ||
  (typeof id === "number" && Number.isSafeInteger(id) && id > 0);

export { FOOTER_HEIGHT, WIZARD_CONTAINER_STYLES };
